import { Form } from 'react-bootstrap';

interface InputBoxProps {
  label: string;
  name: string;
  tabIndex?: number;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  onBlur?: any;
  isValid?: any;
  isInvalid?: any;
  length?: number;
  disabled?: boolean;
}

export const InputBox: React.FC<InputBoxProps> = ({
  label,
  name,
  type = 'text',
  tabIndex,
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  onBlur,
  isValid,
  isInvalid,
  length,
  disabled = false,
}) => {
  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type={type}
        name={name}
        tabIndex={tabIndex}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isValid={isValid}
        isInvalid={isInvalid}
        maxLength={length}
        disabled={disabled}
      />
      <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
    </Form.Group>
  );
};
